import Vue from "vue";
import VueRouter from "vue-router";
import { staticRoute } from "./routes";
import { getUserInfo } from "@/api/modules/login";
import store from "@/store";
Vue.use(VueRouter);

console.log(staticRoute, 1221212);
const router = new VueRouter({
  routes: staticRoute,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// 解决报错
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
export default router;
router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  console.log(to, 233223);
  if (to.query.token) {
    console.log(JSON.parse(decodeURIComponent(to.query.token)));
    await store.commit("setUserInfo", {
      ...JSON.parse(decodeURIComponent(to.query.token)),
    });
    const userInfo = await getUserInfo();

    if (userInfo.code === 0) {
      await store.commit("setUserInfo", {
        ...userInfo.data,
        token: JSON.parse(decodeURIComponent(to.query.token)).token,
      });
    }

    // 创建新的查询参数对象，排除token
    const query = { ...to.query };
    delete query.token;
    
    // 重定向到没有token参数的新路由
    next({
      path: to.path,
      query: query,
      replace: true  // 使用replace模式，这样浏览器历史记录不会新增记录
    });
    return;
  }

  next();
});
